import React, { useEffect }    from 'react';
import LayoutBrowseContainer   from "../../../containers/LayoutBrowseContainer";
import PlayerContainer         from "../../../containers/PlaybackPlayer";
import TimelineContainer       from "../../../containers/TimelineContainer";
import InitBrowsePaneComponent from "../InitBrowsePaneComponent";
import './style.css';

const {CONFIG} = window;

const BrowsemodeComponent = () => {
  const {height} = CONFIG.browseLayout;

  const style = {
    height: height + 'vh'
  };

  useEffect(() => {
    // dispatch(setInitialCameras(currentCameras));
    // return () => {
    //   dispatch(setCurrentCameras(initialCameras));
    // }
  }, []);

  return (
    <div className='w-100 h-100 browse'>
      <div className='browse-layout'
           style={style}
      >
        <LayoutBrowseContainer>
          <InitBrowsePaneComponent pane={0} isThumbnail={false}/>
        </LayoutBrowseContainer>
      </div>
      <TimelineContainer/>
      <PlayerContainer/>
    </div>
  )
};

export default BrowsemodeComponent



